{
    "v": "5.12.1",
    "fr": 25,
    "ip": 0,
    "op": 50,
    "w": 500,
    "h": 500,
    "nm": "06 Hammer",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 3,
            "nm": "Main Stroke width - Color Ctrl",
            "parent": 9,
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [0, 0, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [50, 50, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ef": [
                {
                    "ty": 5,
                    "nm": "Stroke width",
                    "np": 3,
                    "mn": "ADBE Slider Control",
                    "ix": 1,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 0,
                            "nm": "Slider",
                            "mn": "ADBE Slider Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": 24, "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Base Color",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 2,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": { "a": 0, "k": [0, 0, 0, 1], "ix": 1 }
                        }
                    ]
                },
                {
                    "ty": 5,
                    "nm": "Highlight",
                    "np": 3,
                    "mn": "ADBE Color Control",
                    "ix": 3,
                    "en": 1,
                    "ef": [
                        {
                            "ty": 2,
                            "nm": "Color",
                            "mn": "ADBE Color Control-0001",
                            "ix": 1,
                            "v": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 1
                            }
                        }
                    ]
                }
            ],
            "ip": 0,
            "op": 50,
            "st": -3,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "line 6",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [147, -76],
                                        [200, -44]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.38], "y": [1] },
                                        "o": { "x": [0.62], "y": [0] },
                                        "t": 32,
                                        "s": [0]
                                    },
                                    { "t": 37, "s": [100] }
                                ],
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.38], "y": [1] },
                                        "o": { "x": [0.62], "y": [0] },
                                        "t": 30,
                                        "s": [0]
                                    },
                                    { "t": 35, "s": [100] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Trim Paths 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 30,
            "op": 37,
            "st": 11,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "line 5",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [138, -38],
                                        [162, 3]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.38], "y": [1] },
                                        "o": { "x": [0.62], "y": [0] },
                                        "t": 32,
                                        "s": [0]
                                    },
                                    { "t": 37, "s": [100] }
                                ],
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.38], "y": [1] },
                                        "o": { "x": [0.62], "y": [0] },
                                        "t": 30,
                                        "s": [0]
                                    },
                                    { "t": 35, "s": [100] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Trim Paths 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 30,
            "op": 37,
            "st": 11,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "line 4",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [166, -109],
                                        [213, -124]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.38], "y": [1] },
                                        "o": { "x": [0.62], "y": [0] },
                                        "t": 32,
                                        "s": [0]
                                    },
                                    { "t": 37, "s": [100] }
                                ],
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.38], "y": [1] },
                                        "o": { "x": [0.62], "y": [0] },
                                        "t": 30,
                                        "s": [0]
                                    },
                                    { "t": 35, "s": [100] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Trim Paths 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 30,
            "op": 37,
            "st": 11,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "line 3",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [147, -76],
                                        [200, -44]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.38], "y": [1] },
                                        "o": { "x": [0.62], "y": [0] },
                                        "t": 21,
                                        "s": [0]
                                    },
                                    { "t": 26, "s": [100] }
                                ],
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.38], "y": [1] },
                                        "o": { "x": [0.62], "y": [0] },
                                        "t": 19,
                                        "s": [0]
                                    },
                                    { "t": 24, "s": [100] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Trim Paths 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 19,
            "op": 26,
            "st": 0,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "line 2",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [138, -38],
                                        [162, 3]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.38], "y": [1] },
                                        "o": { "x": [0.62], "y": [0] },
                                        "t": 21,
                                        "s": [0]
                                    },
                                    { "t": 26, "s": [100] }
                                ],
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.38], "y": [1] },
                                        "o": { "x": [0.62], "y": [0] },
                                        "t": 19,
                                        "s": [0]
                                    },
                                    { "t": 24, "s": [100] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Trim Paths 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 19,
            "op": 26,
            "st": 0,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "line",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [166, -109],
                                        [213, -124]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.38], "y": [1] },
                                        "o": { "x": [0.62], "y": [0] },
                                        "t": 21,
                                        "s": [0]
                                    },
                                    { "t": 26, "s": [100] }
                                ],
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": { "x": [0.38], "y": [1] },
                                        "o": { "x": [0.62], "y": [0] },
                                        "t": 19,
                                        "s": [0]
                                    },
                                    { "t": 24, "s": [100] }
                                ],
                                "ix": 2
                            },
                            "o": { "a": 0, "k": 0, "ix": 3 },
                            "m": 1,
                            "ix": 2,
                            "nm": "Trim Paths 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.157, 0.176, 0.212, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 19,
            "op": 26,
            "st": 0,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "hammer",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.38], "y": [1] },
                            "o": { "x": [0.62], "y": [0] },
                            "t": 2,
                            "s": [0]
                        },
                        {
                            "i": { "x": [0.38], "y": [1] },
                            "o": { "x": [0.62], "y": [0] },
                            "t": 15,
                            "s": [-14]
                        },
                        {
                            "i": { "x": [0.38], "y": [1] },
                            "o": { "x": [0.62], "y": [0] },
                            "t": 21,
                            "s": [18]
                        },
                        {
                            "i": { "x": [0.38], "y": [1] },
                            "o": { "x": [0.62], "y": [0] },
                            "t": 27,
                            "s": [-14]
                        },
                        {
                            "i": { "x": [0.38], "y": [1] },
                            "o": { "x": [0.62], "y": [0] },
                            "t": 33,
                            "s": [18]
                        },
                        { "t": 47, "s": [0] }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.38, "y": 1 },
                            "o": { "x": 0.62, "y": 0 },
                            "t": 2,
                            "s": [250, 250, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.38, "y": 1 },
                            "o": { "x": 0.62, "y": 0 },
                            "t": 15,
                            "s": [199, 228, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.38, "y": 1 },
                            "o": { "x": 0.62, "y": 0 },
                            "t": 21,
                            "s": [227, 238, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.38, "y": 1 },
                            "o": { "x": 0.62, "y": 0 },
                            "t": 27,
                            "s": [199, 228, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.38, "y": 1 },
                            "o": { "x": 0.62, "y": 0 },
                            "t": 33,
                            "s": [227, 238, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 47, "s": [250, 250, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [136.627, 181.952, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 7.414],
                                        [44.451, 0],
                                        [42.325, 0],
                                        [0, 0],
                                        [-75.951, 0],
                                        [-37.809, -1.778],
                                        [-7.414, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [-41.65, 0],
                                        [-63.478, 0],
                                        [0, 0],
                                        [55.65, 0],
                                        [57.859, 0],
                                        [0, -7.414],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-7.414, 0]
                                    ],
                                    "v": [
                                        [93.34, 30.62],
                                        [2.624, 9.214],
                                        [-111.82, 42.417],
                                        [-126.175, 16.1],
                                        [2.624, -44.1],
                                        [93.34, 0.18],
                                        [106.82, -13.3],
                                        [126.175, -13.3],
                                        [126.175, 44.1],
                                        [106.82, 44.1]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0.20000001496, 0.800000059838, 0.800000059838, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Highlight')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [136.627, 54.552], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [30.537, -22.631],
                                        [25.696, 22.631],
                                        [-25.757, 22.631],
                                        [-30.536, -22.051]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [136.658, 93.871], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [10.588, 0],
                                        [0, 10.587],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 10.587],
                                        [-10.588, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [19.25, -116.725],
                                        [19.25, 97.476],
                                        [0, 116.725],
                                        [-19.25, 97.476],
                                        [-19.25, -116.725]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [0, 0, 0, 1],
                                "ix": 3,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Base Color')('Color');"
                            },
                            "o": { "a": 0, "k": 100, "ix": 4 },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5,
                                "x": "var $bm_rt;\n$bm_rt = thisComp.layer('Main Stroke width - Color Ctrl').effect('Stroke width')('Slider');"
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [136.627, 236.726], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 50,
            "st": 0,
            "ct": 1,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 9,
            "ty": 3,
            "nm": "Zero | troke width - Color Ctrl 2",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 0, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [250, 250, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "ip": 0,
            "op": 50,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": [],
    "props": {}
}
